import { ProofOfDeliveryDownloadFileParams, ProofOfDeliverySaveParams } from '../../../../common';
import { MatDialogRef } from '@angular/material/dialog';

export class PublicProofOfDeliveryLoad {
  public static readonly type = '[Public Proof Of Delivery] Load';
  constructor(public payload: string) {}
}

export class PublicProofOfDeliverySave {
  public static readonly type = '[Public Proof Of Delivery] Save';
  constructor(public payload: ProofOfDeliverySaveParams) {}
}

export class PublicProofOfDeliveryDownloadFile {
  public static readonly type = '[Public Proof Of Delivery] Download File';
  constructor(public payload: ProofOfDeliveryDownloadFileParams) {}
}

export class PublicProofOfDeliveryFeedback {
  public static readonly type = '[Public Proof Of Delivery] Send feedback';
  constructor(
    public payload: {
      data: { text: string };
      token: string;
      dialogRef: MatDialogRef<unknown>;
    },
  ) {}
}

export class PublicProofOfDeliveryInitialState {
  public static readonly type = '[Public Proof Of Delivery] Set Initial State';
}
